import { currentTimeMillis, Day, exists, filterDuplicates, filterInstances, Hour, Minute, MUSTNeverHappenException, randomFromArray, randomNumber, StaticLogger, Week } from '@nu-art/ts-common';
import { ModuleFE_Value, ModuleFE_Variable } from '@app/hcs-frontend';
import { valueType_Enumerated, valueType_Range, valueType_StandardRange, valueType_Tuple } from '@app/hcs-shared';
const getNumericResult = (normal, prev) => {
    const getVal = () => {
        const min = Math.floor(normal[0] * 0.75);
        const max = Math.floor(normal[1] * 1.25);
        return randomNumber([min, max]);
    };
    const currentVisit = prev?.currentVisit === false ? false : randomFromArray([true, false]);
    const timestamp = currentVisit
        ? (exists(prev) ? prev.timestamp - randomNumber([30 * Minute, 2 * Hour]) : currentTimeMillis())
        : (exists(prev) ? prev.timestamp - randomNumber([Day, Week]) : currentTimeMillis() - randomNumber([Day, Week]));
    return {
        value: getVal(),
        currentVisit,
        timestamp,
        normalMin: normal[0],
        normalMax: normal[1],
    };
};
const getNumericResults = (range) => {
    const arr = Array.from({ length: randomNumber([4, 10]) });
    arr.forEach((_, i) => {
        const prev = i === 0 ? undefined : arr[i - 1];
        arr[i] = getNumericResult(range, prev);
    });
    return arr;
};
const getEnumResults = (scope) => {
    const getVal = () => randomFromArray(scope);
    return [
        { value: getVal(), timestamp: currentTimeMillis(), currentVisit: true },
        { value: getVal(), timestamp: currentTimeMillis() - Hour, currentVisit: true },
        { value: getVal(), timestamp: currentTimeMillis() - (2 * Day), currentVisit: false },
    ];
};
export const mockFishboneResults = (struct) => {
    let varIds = struct.ribs.reduce((arr, rib) => {
        return [...arr, ...rib.ribItems.map(item => randomFromArray(item.variableIds))];
    }, []);
    varIds = filterDuplicates(filterInstances([...varIds, randomFromArray(struct.head?.variableIds), randomFromArray(struct.tail?.variableIds)]));
    return varIds.reduce((results, varId) => {
        const variable = ModuleFE_Variable.cache.unique(varId);
        if (!variable)
            throw new MUSTNeverHappenException(`Could not get variable for id ${varId}`);
        const value = ModuleFE_Value.cache.unique(variable.valueId);
        if (!value)
            throw new MUSTNeverHappenException(`Could not get value for id ${variable.valueId}`);
        switch (value.type) {
            case valueType_Range: {
                const range = value.data.scope;
                results[varId] = getNumericResults(range);
                break;
            }
            case valueType_StandardRange: {
                const range = value.data.fullRange;
                results[varId] = getNumericResults(range);
                break;
            }
            case valueType_Enumerated:
            case valueType_Tuple: {
                const scope = value.data.scope;
                results[varId] = getEnumResults(scope);
                break;
            }
            default: {
                StaticLogger.logWarning(`Unsupported value type in fishbone struct "${struct.label}" for variable "${variable.name}": ${value.type}`);
                results[varId] = getNumericResults([1, 100]);
            }
        }
        return results;
    }, {});
};
//# sourceMappingURL=mock-results.js.map